module.exports = __webpack_public_path__ + "static/media/price-is-right-horn.481ed276.mp3";